export const TRANSLATION_KEYS = {
    Heading: "settingPage.holidaysDrawer.heading",
    ApplyText: "common.applyText",
    ConfirmText: "common.saveText",
    DismissText: "common.dismissText",
    DialogContent: "settingPage.holidaysDrawer.addDateDialog.content",
    AddContent: "settingPage.holidaysDrawer.addDateDialog.add",
    RemoveContent: "settingPage.holidaysDrawer.addDateDialog.remove"
};